import React from 'react';
import { Layout } from 'antd';
import AppHeader from './Header';
import NavigationTabs from './NavigationTabs';
import WeatherAlertModal from './WeatherAlertModal';
import { useAuth } from '../context/AuthContext';

const { Content } = Layout;

const AppLayout = ({ children }) => {
  const { selectedGreenhouse } = useAuth();

  return (
    <Layout style={{ minHeight: '100vh', width: '100%' }}>
      <AppHeader />
      <Content className="app-content-area">
        <NavigationTabs />
        <div className="content-inner-wrapper">
          {children}
        </div>
      </Content>
      {selectedGreenhouse && (
        <WeatherAlertModal key={selectedGreenhouse} greenhouseId={selectedGreenhouse} />
      )}
    </Layout>
  );
};

export default AppLayout;


